"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplacePreparation = void 0;
const native_base_1 = require("native-base");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const organisms_1 = require("../../../organisms");
const AbortFUPModal_1 = require("./AbortFUPModal");
const lodash_1 = __importDefault(require("lodash"));
const FollowPrescription_style_1 = require("../FollowPrescription.style");
const atome_1 = require("../../../atome");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
function ReplacePreparation(props) {
    const { navigation, setCurrentPage, showFUPRModal, setShowFUPRModal } = props;
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const prescriptionInfo = (0, hooks_1.useAppSelector)(reducers_1.selectPrescriptionInfo);
    const [prescriptionTemp, setPrescriptionTemp] = (0, react_1.useState)(prescriptionInfo);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const lastMedication = userInformation?.medication[userInformation.medication.length - 1];
    const handleBackButton = () => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 9,
            },
        };
        setCurrentPage(reducerType);
    };
    const next = () => {
        dispatch((0, reducers_1.setPrescriptionInfo)(prescriptionTemp));
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 11,
            },
        };
        setCurrentPage(reducerType);
    };
    const handleCheckboxesChange = (value, index) => {
        const newPrescriptionInfo = lodash_1.default.cloneDeep(prescriptionTemp);
        if (value === false) {
            newPrescriptionInfo.preparationQuestion[index].exchangeWithThisPreparation = '';
        }
        newPrescriptionInfo.preparationQuestion[index].changeThisPreparation =
            value;
        setPrescriptionTemp(newPrescriptionInfo);
    };
    const handleInputTextChange = (value, index) => {
        const newPrescriptionInfo = lodash_1.default.cloneDeep(prescriptionTemp);
        newPrescriptionInfo.preparationQuestion[index].exchangeWithThisPreparation =
            value;
        setPrescriptionTemp(newPrescriptionInfo);
    };
    const renderPreparationsItems = (preparations) => !preparations.length ? (react_1.default.createElement(native_base_1.View, null,
        react_1.default.createElement(native_base_1.Text, null, "Preparation List Items Empty"))) : preparations.length === 1 ? (preparations.map((item, index) => (react_1.default.createElement(native_base_1.VStack, { key: index, w: "100%", p: "5" },
        react_1.default.createElement(native_base_1.TextArea, { autoCompleteType: "off", fontSize: "md", h: "100", bgColor: "#EFEFEE", p: 3, borderRadius: "3xl", borderWidth: 0, defaultValue: item?.exchangeWithThisPreparation, placeholder: 'Austauschpräparat eingeben...\nBitte mindestens Name und Kultivar des Präparates angeben.', onChangeText: value => handleInputTextChange(value, index) }))))) : (preparations.map((item, index) => (react_1.default.createElement(native_base_1.VStack, { space: 5, mt: "2", p: "5", key: index, w: "100%", bgColor: '#f8f8f8' },
        react_native_1.Platform.OS === 'web' && (react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', onChange: value => handleCheckboxesChange(value, index), isChecked: item?.changeThisPreparation, value: item?.changeThisPreparation },
            react_1.default.createElement(native_base_1.Text, { ml: "2" }, lastMedication?.preparationListItem[index].name))),
        react_native_1.Platform.OS !== 'web' && (
        // Custom Checkbox for mobile we had some issues with Native Base Library checkboxes
        react_1.default.createElement(react_native_1.TouchableOpacity, { style: { flexDirection: 'row' }, onPress: () => handleCheckboxesChange(!item?.changeThisPreparation, index) },
            react_1.default.createElement(native_base_1.View, { style: item?.changeThisPreparation
                    ? FollowPrescription_style_1.styles.checked
                    : FollowPrescription_style_1.styles.unchecked }, item?.changeThisPreparation && (react_1.default.createElement(atome_1.Icon, { icon: 'checked', size: 15, background: false }))),
            react_1.default.createElement(native_base_1.Text, { style: { marginLeft: 15 } }, lastMedication?.preparationListItem[index].name))),
        item?.changeThisPreparation && (react_1.default.createElement(native_base_1.TextArea, { autoCompleteType: "off", fontSize: "md", w: "100%", h: "100", bgColor: "#EFEFEE", p: 3, borderRadius: "3xl", borderWidth: 0, value: item?.exchangeWithThisPreparation, placeholder: 'Austauschpräparat eingeben...\nBitte mindestens Name und Kultivar des Präparates angeben.', onChangeText: value => handleInputTextChange(value, index) }))))));
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(atome_1.BetterScrollView, null,
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(native_base_1.VStack, { space: 5, alignItems: 'center', style: GlobalStyles_1.globalStyles.mobileToWebContainer },
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "20" },
                    react_1.default.createElement(native_base_1.Text, { fontSize: "2xl", textAlign: "center", color: "#3db384", fontWeight: "bold" }, "Austauschpr\u00E4parat")),
                react_1.default.createElement(native_base_1.Center, { w: "90%", mt: "3", mb: "3" },
                    react_1.default.createElement(native_base_1.Text, { textAlign: "center" }, "Bitte teilen Sie uns Ihr Wunschpr\u00E4parat mit.")),
                react_1.default.createElement(native_base_1.Center, { w: "90%", mb: "4" },
                    react_1.default.createElement(native_base_1.Text, { textAlign: "center", w: "90%" }, "Beachten Sie, dass abschlie\u00DFend Ihr behandelnder Arzt entscheidet, welches Pr\u00E4parat verschrieben wird. Eine Dosiserh\u00F6hung ist nicht m\u00F6glich. Stark abweichende Pr\u00E4parate im THC-Gehalt zur vorherigen Medikation f\u00FChren zu einer m\u00F6glichen Ablehnung des Folgerezeptantrags."),
                    react_1.default.createElement(native_base_1.Text, { mt: "10", mb: "2", textAlign: "center", fontWeight: "bold" }, lastMedication?.preparationListItem?.length === 1
                        ? 'Welches Austauschpräparat wünschen Sie?'
                        : 'Welche Präparate möchten Sie austauschen? '),
                    renderPreparationsItems(prescriptionTemp?.preparationQuestion),
                    react_1.default.createElement(native_base_1.HStack, { space: [4, 10], justifyContent: "center", pb: "25" },
                        react_1.default.createElement(native_base_1.Button, { mt: "12", w: "40%", backgroundColor: '#fff', borderRadius: "3xl", _text: { color: '#3db384', fontWeight: 'bold', underline: true }, onPress: handleBackButton }, "Zur\u00FCck"),
                        react_1.default.createElement(native_base_1.Button, { mt: "12", w: ['40%', '80%'], backgroundColor: '#3db384', borderRadius: "3xl", _text: { color: '#fff', fontWeight: 'bold' }, onPress: next }, "Weiter")))),
            react_1.default.createElement(AbortFUPModal_1.AbortFUPModal, { navigation: navigation, setCurrentPage: setCurrentPage, showFUPRModal: showFUPRModal, setShowFUPRModal: setShowFUPRModal }))));
}
exports.ReplacePreparation = ReplacePreparation;
